import React, { memo } from 'react'
import PropTypes from 'prop-types'

import styles from './skillItem.module.scss'

function SkillItem(props) {
  const { iconSrc } = props

  return (
    <div className={styles.container}>
      <img src={iconSrc} alt="logo" />
    </div>
  )
}

SkillItem.defaultProps = {
  iconSrc: '',
}

SkillItem.propTypes = {
  iconSrc: PropTypes.string,
}

export default memo(SkillItem)
